import React from "react";
import PropTypes from "prop-types";
import { Modal } from "react-bootstrap";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { selectKycProcess } from "../../store/user/selectors";
import StepIntro from "./StepIntro";
import StepSignIn from "./StepSignIn";
import StepIdenfy from "./StepIdenfy";
import StepChecks from "./StepChecks";
import StepStatus from "./StepStatus";
import StepLiteracyTest from "./StepLiteracyTest";
import "./style.scss";

const KYCFormModal = ({ t, show, onHide, canTransact, kycProcess }) => {
  const { step } = kycProcess;

  const stepConfig = {
    intro: {
      component: <StepIntro />,
      titleKey: "Sign Up to Ensuro",
      labelKey: "Intro",
      visible: true,
    },
    signIn: {
      component: <StepSignIn />,
      titleKey: "Accept Terms",
      labelKey: "Accept Terms",
      visible: true,
    },
    literacyTest: {
      component: <StepLiteracyTest />,
      titleKey: "Investor Test",
      labelKey: "Investor Test",
      visible: true,
    },
    idenfy: {
      component: <StepIdenfy />,
      titleKey: "Idenfy identity verification",
      labelKey: "KYC",
      visible: true,
    },
    verificationDetails: {
      component: <StepChecks onHide={onHide} />,
      titleKey: "Final checks",
      labelKey: "Checks",
      visible: true,
    },
    kycStatus: {
      component: <StepStatus onHide={onHide} />,
      titleKey: "Verification status",
      labelKey: "Status",
      visible: step === "kycStatus",
    },
  };

  const visibleSteps = Object.entries(stepConfig).filter(([, cfg]) => cfg.visible);
  const stepsOrder = visibleSteps.map(([key]) => key);
  const currentStep = stepConfig[step];

  return (
    <Modal show={show} centered onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title className="link-style-title">{t(currentStep?.titleKey || "")}</Modal.Title>
      </Modal.Header>

      <div className="d-flex justify-content-between align-items-center px-4 pt-3 pb-2">
        {stepsOrder.map((key, index) => {
          const isCurrent = key === step;
          const label = t(stepConfig[key].labelKey);

          return (
            <div key={key} className="text-center flex-fill">
              <div
                className={`rounded-circle mx-auto mb-1 ${isCurrent ? "bg-primary text-white" : "bg-light text-muted"}`}
                style={{
                  width: "28px",
                  height: "28px",
                  lineHeight: "28px",
                  fontSize: "14px",
                }}
              >
                {index + 1}
              </div>
              <div style={{ fontSize: "12px" }}>{label}</div>
            </div>
          );
        })}
      </div>

      <Modal.Body>{currentStep?.component || null}</Modal.Body>

      {!canTransact && (
        <Modal.Footer>
          <p className="read-only">{t("Read-only mode. Connect to a wallet to perform transactions.")}</p>
        </Modal.Footer>
      )}
    </Modal>
  );
};

KYCFormModal.propTypes = {
  t: PropTypes.any,
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  canTransact: PropTypes.bool,
  kycProcess: PropTypes.object.isRequired,
  kycSignature: PropTypes.object,
};

const mapStateToProps = (state) => {
  const canTransact = state.UserReducer.canTransact;
  const kycProcess = selectKycProcess(state.UserReducer);

  return {
    canTransact,
    kycProcess,
  };
};

export default connect(mapStateToProps)(withTranslation()(KYCFormModal));
